require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-nathan-coder-entrepreneur-and-founder-of-pennypost.json") })
        }
      }, "path---blog-meet-nathan-coder-entrepreneur-and-founder-of-pennypost");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-nathan-coder-entrepreneur-and-founder-of-pennypost!./.cache/json/blog-meet-nathan-coder-entrepreneur-and-founder-of-pennypost.json
// module id = 966
// module chunks = 231608221292675